import React from "react";

import clsx from "clsx";

export interface Props {
  value: number;
  isPositiveChangeGood: boolean;
}

export const ChangeFractionDisplay = ({
  value,
  isPositiveChangeGood,
}: Props) => {
  let inner: React.ReactNode = "—%";

  const classes: Record<string, boolean> = {};
  let icon = null;

  if (value && !Number.isNaN(value)) {
    const positiveChange = value >= 0;
    if (positiveChange) {
      classes["text-good"] = isPositiveChangeGood;
      classes["text-bad"] = !isPositiveChangeGood;
      icon = (
        <i className="fa-regular fa-sharp fa-arrow-up font-semibold text-xxs mr-0.5" />
      );
    } else {
      classes["text-bad"] = isPositiveChangeGood;
      classes["text-good"] = !isPositiveChangeGood;
      icon = (
        <i className="fa-regular fa-sharp fa-arrow-down font-semibold text-xxs mr-0.5" />
      );
    }

    const absValue =
      Math.abs(value) >= 1e9 // 1 billion
        ? "∞"
        : (Math.abs(value) * 100).toFixed(1);

    let out = `${absValue}%`;
    if (!positiveChange) {
      out = `(${out})`;
    } else {
      out = `${out}`;
    }

    inner = (
      <>
        {icon}
        {out}
      </>
    );
  }

  return (
    <small className={clsx(classes, "text-xs tracking-tight")}>{inner}</small>
  );
};
